// ─── Feedback tátil ──────────────────────────────────────────────────────────
// Gestos (segurar para copiar, swipe para fechar) ficam muito mais claros com
// uma vibração curta. A API não existe em iOS/desktop: nesse caso o retorno é
// `false` e nada acontece — nenhum consumidor precisa checar suporte.

const PADROES = Object.freeze({
  leve: 8,
  confirmacao: Object.freeze([10, 40, 14]),
});

/**
 * Vibra o dispositivo quando possível.
 *
 * @param {'leve'|'confirmacao'} tipo Intensidade do feedback.
 * @returns {boolean} `true` quando a vibração foi solicitada com sucesso.
 */
export const vibrar = (tipo = 'leve') => {
  if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return false;

  const padrao = PADROES[tipo] ?? PADROES.leve;

  try {
    return navigator.vibrate(padrao);
  } catch (error) {
    // Alguns navegadores lançam em contextos sem permissão (iframe, economia de
    // energia). Feedback tátil é opcional: seguimos sem ele.
    return false;
  }
};

export default vibrar;
